var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"json-toggle",class:{
    'json-toggle__collapsed': this.expanded,
    'json-toggle__expanded': !this.expanded,
  },on:{"click":_vm.toggle}},[_c(_vm.collapseIcon,{directives:[{name:"show",rawName:"v-show",value:(this.expanded),expression:"this.expanded"}],tag:"component"}),_c(_vm.expandIcon,{directives:[{name:"show",rawName:"v-show",value:(!this.expanded),expression:"!this.expanded"}],tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }